import React from 'react';
import Joi from 'joi-browser';
import Form from './common/form';
import { getTradeType, saveTradeType } from '../services/tradeTypeService';

class TradeTypeForm extends Form {
  state = {
    data: {
      name: '',
    },
    errors: {},
  };

  schema = {
    _id: Joi.string(),
    name: Joi.string().required().label('Trade Type Name'),
  };

  async populateTradeType() {
    try {
      const tradeTypeId = this.props.match.params.id;
      if (tradeTypeId === 'new') return;

      const { data: ttype } = await getTradeType(tradeTypeId);
      this.setState({ data: this.mapToViewModel(ttype) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        return this.props.history.replace('/not-found');
    }
  }

  async componentDidMount() {
    await this.populateTradeType();
  }

  mapToViewModel(ttype) {
    return {
      _id: ttype._id,
      name: ttype.name,
    };
  }

  doSubmit = async () => {
    const { data } = this.state;
    // Call the server

    await saveTradeType(data);

    this.props.history.push('/trade-types');
  };

  render() {
    const tradeTypeId = this.props.match.params.id;
    return (
      <div className="row">
        <div className="col-md-6 offset-md-3" style={{ marginTop: 50 + 'px' }}>
          <div className="text-center">
            <h4
              className="h4 mb-2 login-welcome-text"
              style={{ marginTop: 20 + 'px', fontWeight: 'bold' }}
            >
              Create a Trade Type
            </h4>
            <p style={{ color: '#000524' }}>
              This operation can only be performed by Jeroid Admin
            </p>
          </div>
          <div
            className="card card-register mx-auto mt-2"
            style={{ border: 0, borderRadius: 0, marginBottom: 10 + '%' }}
          >
            <div
              className="card-header"
              style={{
                backgroundColor: 'white',
                borderBottom: 0,
                marginTop: 2 + '%',
                fontWeight: 'bold',
              }}
            >
              Trade Info
            </div>
            <hr
              style={{
                marginRight: 20 + 'px',
                marginLeft: 20 + 'px',
                marginTop: 0,
                marginBottom: 0,
              }}
            />
            <div className="card-body">
              <form onSubmit={this.handleSubmit}>
                <div className="form-row">
                  <div className="col-md-12">
                    {this.renderInput(
                      'name',
                      'Trade Type Name',
                      '',
                      'autofocus',
                      'text'
                    )}
                  </div>
                </div>

                <div className="text-center">
                  {tradeTypeId === 'new'
                    ? this.renderButton('Save')
                    : this.renderButton('Update')}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TradeTypeForm;
